import React, { useContext, useState } from 'react';

import { createAnexoDemanda } from '@app/api/demanda';
import {
  MasterDetailForm
} from '@digital/ui';

import QuestionarioContext from '@app/hooks/useQuestionario';
import { UploadFileFaturamentoDireto } from '@app/components/Upload/uploadFileFaturamentoDireto';

interface Props {
  onUpdate: () => any;
  DescricaoDocumento : string
}

function IncluirAnexoFaturamentoDireto(props: Props) {
  const { onUpdate } = props;
  const { demandaData } = useContext(QuestionarioContext);
  const [arquivo, setArquivo] = useState<boolean>(true);

  const handleSubmit = (values: any) => {
    values.demandaId = demandaData && demandaData.id;
    createAnexoDemanda(values).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleUploadChange = (info: any) => {

  const file = info.file;

  if (file) {
    const values = {
      demandaId: demandaData &&  demandaData.id,
      Obrigatorio: true,
      DescricaoDocumento: props.DescricaoDocumento,
      arquivo: file,
    };
      createAnexoDemanda(values).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  }
};

  return (
    <>
      <MasterDetailForm
        key="formAnexo"
        onSubmit={handleSubmit}
        >
        <UploadFileFaturamentoDireto
          idDoComponente="upload-anexo-faturamento"
          nameFormData={'arquivo'}
          label={'Anexar'}
          hasFile={arquivo}
          type="primary"
          onChange={handleUploadChange}          
        />
      </MasterDetailForm>
    </>
  );
}

export default IncluirAnexoFaturamentoDireto;
